// @packages
import React, { useEffect, useState } from 'react';
import { MaterialCommunityIcons, Feather } from '@expo/vector-icons';
import { View } from 'react-native';
import Toggle from 'react-native-toggle-element';
import { useTheme } from '@rneui/themed';

// @scripts
import TestingService from '../../../services/testing-service';
import {
  Durations,
  EStatus,
  ISession
} from '../../../utils/types';
import { config } from '../../../core/config';
import { format } from '../../../utils/string';
import { globalUI } from '../../../core';

type Props = {
  currentSiteId: number
  initialSession: ISession|undefined
};

const ToggleWithIcon = ({
  currentSiteId,
  initialSession
}: Props) => {
  const { theme } = useTheme();

  const [currentSession, setCurrentSession] = useState<ISession | undefined>(initialSession);
  const detectToggleState = () => {
    const status = currentSession?.status ?? currentSession?.session_status;
    const isCustomerStrategy = currentSession?.strategy_id === 1
    return [currentSession != null && !isCustomerStrategy, (status === EStatus.ACTIVE) && !isCustomerStrategy];
  };
  const [initialSwitchable, initialStarted] = detectToggleState();
  const [switchable, setSwitchable] = useState(initialSwitchable);
  const [started, setStarted] = useState(initialStarted);

  useEffect(() => {
    const [currentSwitchable, currentStarted] = detectToggleState();
    setSwitchable(currentSwitchable);
    setStarted(currentStarted);
  }, [currentSession]);

  const changeToggle = async () => {
    if (currentSession == null) return;
    const start = !started;
    setStarted(start);
    const id = currentSession?.id ?? currentSession?.session_id;
    const method = start ? 'resumeSession' : 'pauseSession';
    const message = start
      ? config.text.siteScheduleDetail.sessionStartedMessage
      : config.text.siteScheduleDetail.sessionStoppedMessage;
    if (id != null) {
      setCurrentSession(await TestingService[method](currentSiteId, id));
      globalUI.showToast(message, Durations.SHORT);
    }
  };

  return (
    <View pointerEvents={switchable ? 'auto' : 'none'}>
      <Toggle
        disabled={!switchable}
        onPress={changeToggle}
        value={started}
        thumbActiveComponent={<MaterialCommunityIcons name="robot-outline" color="black" size={25} />}
        thumbInActiveComponent={<Feather name="calendar" color="black" size={25} />}
        thumbButton={{
          activeBackgroundColor: 'white',
          inActiveBackgroundColor: 'white',
          borderWidth: 100
        }}
        trackBar={{
          activeBackgroundColor: theme.colors.searchBg,
          inActiveBackgroundColor: theme.colors.grey0,
          borderActiveColor: theme.colors.searchBg,
          borderInActiveColor: theme.colors.grey0,
          borderWidth: 5,
          width: 100
        }}
      />
    </View>
  );
};

export default ToggleWithIcon;
